module.exports = __webpack_public_path__ + "img/hr-V-L-135-load-standup-base.94668d10.png";